<div class="report-history-container">
  <!-- Header Section -->
  <div class="header-section">
    <h1 class="page-title">Reports History</h1>
    <p class="page-subtitle">View and manage your historical verification reports</p>
  </div>

  <!-- Table Section -->
  <div class="table-wrapper">
    <app-admin-common-table
      [tableHeaders]="tableHeaders"
      [tableData]="tableData"
      [paginationConfig]="paginationConfig"
      [loading]="isLoading"
      emptyMessage="No reports found"
      (pageEvent)="onPageChange($event)"
    ></app-admin-common-table>
  </div>
</div>

<!-- Custom Template for View Report Button -->
<ng-template #viewReportTemplate let-row let-field="field">
  <div class="actions-container">
    <button class="view-btn" (click)="viewReport(row)">
      <mat-icon class="text-[16px] flex items-center justify-center">visibility</mat-icon>
      View
    </button>
    <button 
      class="download-btn" 
      *ngIf="hasDownloadableDocuments(row)" 
      (click)="openDownloadDialog(row)"
      matTooltip="Download Documents"
    >
      <mat-icon class="text-[16px] flex items-center justify-center">cloud_download</mat-icon>
    </button>
  </div>
</ng-template>
